import React from "react";

// MUI
import Box from "@mui/material/Box";

const ImageBackgroundBlock = ({ image }) => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: { xs: "350px", sm: "650px" },
            }}
        />
    );
};

export default ImageBackgroundBlock;
